import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as Personnummer from 'personnummer';

export function personNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    try {
      const valid = Personnummer.default.valid(control.value);
      return valid ? null : { invalidPersonnummer: true };
    } catch {// It throws on invalid input
    }
    return { invalidPersonnummer: true };
  };
}
